import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import { isNullOrUndefined } from '@utils/object';
import SubtitleWithColor from './Subtitle';
import messages from './messages';

function OptionListSubtitle({
  minQuantity,
  quantity,
  needsToAdd,
  intl: { formatMessage },
}) {
  const selected = quantity - needsToAdd;
  const hasMinQuantity = !isNullOrUndefined(minQuantity);
  const minNeedsToAdd = hasMinQuantity ? minQuantity - selected : needsToAdd;
  const selectionIsCompleted = needsToAdd === 0;
  const minSelectionIsCompleted = hasMinQuantity && selected >= minQuantity;

  const label = hasMinQuantity
    ? formatMessage(messages.minMaxOptionText, { minQuantity, quantity })
    : formatMessage(messages.optionText, { quantity });

  let actionText = formatMessage(messages.completedSelection);
  if (!selectionIsCompleted) {
    if (minSelectionIsCompleted) {
      actionText = formatMessage(messages.minMaxCompletedSelection, {
        quantity: selected,
      });
    } else {
      const needsToAddQuantity = hasMinQuantity ? minNeedsToAdd : needsToAdd;
      const actionLabel =
        needsToAddQuantity === 1
          ? messages.uncompletedSelectionOne
          : messages.uncompletedSelection;
      actionText = formatMessage(actionLabel, { quantity: needsToAddQuantity });
    }
  }

  return (
    <SubtitleWithColor
      selectionIsCompleted={selectionIsCompleted || minSelectionIsCompleted}
      label={label}
      actionText={actionText}
      separator={false}
    />
  );
}

OptionListSubtitle.propTypes = {
  minQuantity: PropTypes.number,
  quantity: PropTypes.number.isRequired,
  needsToAdd: PropTypes.number.isRequired,
  intl: intlShape,
};

export { OptionListSubtitle };
export default injectIntl(OptionListSubtitle);
